module.exports = __webpack_public_path__ + "static/media/paypal.6f31ba6d.svg";